Ext.define('SA.view.scatterplot.ScatterPlotAttributesPanelItem', {
    alias: 'widget.scatter-plot-attributes-panel-item',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-scatter-plot-attributes-panel-item',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-scatter-plot-attributes-panel-item-button-wrap',

                items: [
                    {
                        xtype: 'check-button',
                        itemId: 'xCheckButton'
                    }
                ]
            }, {
                xtype: 'simple-container',
                cls: 'sa-scatter-plot-attributes-panel-item-button-wrap',

                items: [
                    {
                        xtype: 'check-button',
                        itemId: 'yCheckButton'
                    }
                ]
            }, {
                xtype: 'component',
                cls: 'sa-scatter-plot-attributes-panel-item-label',
                html: SA.EditItemLabelFactory.forAttributes().create(this.dataId)
            }
        ];

        this.callParent();

        this.xCheckButton = this.down('#xCheckButton');
        this.yCheckButton = this.down('#yCheckButton');
    },

    fireChange({axis, checked}) {
        this.fireEvent('change', {axis, attribute: this.getDataId(), checked});
    },

    getDataId() {
        return this.dataId;
    },

    initEvents() {
        this.callParent();

        this.xCheckButton.on('click', this.onXButtonClick, this);
        this.yCheckButton.on('click', this.onYButtonClick, this);
    },

    onXButtonClick(checked) {
        this.fireChange({axis: 'x', checked});
    },

    onYButtonClick(checked) {
        this.fireChange({axis: 'y', checked});
    },

    setState({x, y}) {
        this.xCheckButton.setChecked(x);
        this.yCheckButton.setChecked(y);
    }
});